import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 bg-[#39FF14] rounded-lg flex items-center justify-center">
              <i className="ri-brain-line text-xl text-[#1A3A2E]"></i>
            </div>
            <span className={`text-xl font-bold transition-colors ${
              isScrolled ? 'text-[#1A3A2E]' : 'text-white'
            }`}>
              Entrenamiento Inteligente
            </span>
          </Link>

          <div className="flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#39FF14]' : 'text-white hover:text-[#39FF14]'
              }`}
            >
              Inicio
            </Link>
            <span className={`text-sm font-semibold ${
              isScrolled ? 'text-[#1A3A2E]' : 'text-[#39FF14]'
            }`}>
              Módulo 3
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;